<template>
  <filter-summary
    icon="calendar"
    title="期間"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>当期間：</div>
    <div>{{ baseTermSummary }}</div>
    <div v-if="termType === 'select'">
      {{ baseSelectByDate ? '対象日付' : '対象曜日' }}
    </div>
    <div v-if="termType === 'select'">
      {{ baseSelectByDate ? baseSelectedDatesJoined : baseSelectedDaysJoined }}
    </div>
    <div>前期間：</div>
    <div>{{ compareTermSummary }}</div>
    <div v-if="termType === 'select'">
      {{ compareSelectByDate ? '対象日付' : '対象曜日' }}
    </div>
    <div v-if="termType === 'select'">
      {{
        compareSelectByDate
          ? compareSelectedDatesJoined
          : compareSelectedDaysJoined
      }}
    </div>
  </filter-summary>
</template>

<script>
import { toHumanFriendlyFormat } from '@/util/date'
import { SELECTED_DAY_OPTIONS } from '@/const/termSelectOptions'

import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「期間」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    termType: {
      type: String,
    },
    base: {
      dateFrom: {
        type: String,
      },
      dateTo: {
        type: String,
      },
      selectType: {
        type: String,
      },
      selectedDates: {
        type: Array,
      },
      selectedDays: {
        type: Array,
      },
    },
    compare: {
      dateFrom: {
        type: String,
      },
      dateTo: {
        type: String,
      },
      selectType: {
        type: String,
      },
      selectedDates: {
        type: Array,
      },
      selectedDays: {
        type: Array,
      },
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    baseSelectByDate() {
      return this.base.selectType === 'date'
    },
    compareSelectByDate() {
      return this.compare.selectType === 'date'
    },
    baseTermSummary() {
      if (this.base.dateFrom && this.base.dateTo) {
        return (
          toHumanFriendlyFormat(this.base.dateFrom) +
          ' ～ ' +
          toHumanFriendlyFormat(this.base.dateTo)
        )
      } else {
        return ''
      }
    },
    compareTermSummary() {
      if (this.compare.dateFrom && this.compare.dateTo) {
        return (
          toHumanFriendlyFormat(this.compare.dateFrom) +
          ' ～ ' +
          toHumanFriendlyFormat(this.compare.dateTo)
        )
      } else {
        return ''
      }
    },
    baseSelectedDatesJoined() {
      return (
        [...this.base.selectedDates]
          .sort((a, b) => a - b)
          .map(m => `${m}日`)
          .join(',') || '-'
      )
    },
    compareSelectedDatesJoined() {
      return (
        [...this.compare.selectedDates]
          .sort((a, b) => a - b)
          .map(m => `${m}日`)
          .join(',') || '-'
      )
    },
    baseSelectedDaysJoined() {
      if (!this.base.selectedDays) {
        return '-'
      }
      return (
        [...SELECTED_DAY_OPTIONS]
          .sort((a, b) => a.order - b.order)
          .filter(f => this.base.selectedDays.includes(f.id))
          .map(m => m.label)
          .join(',') || '-'
      )
    },
    compareSelectedDaysJoined() {
      if (!this.compare.selectedDays) {
        return '-'
      }
      return (
        [...SELECTED_DAY_OPTIONS]
          .sort((a, b) => a.order - b.order)
          .filter(f => this.compare.selectedDays.includes(f.id))
          .map(m => m.label)
          .join(',') || '-'
      )
    },
  },
}
</script>
